// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__eP1Tx","dot":"styles_dot__1ZJh2","blink":"styles_blink___SYo5"};